import { NewsItemValue } from './news-item.value';

export class NewsItemValueDto {
    title: string;
    description: string;
    date: number;

    constructor(data: NewsItemValue) {
        this.title = data.title;
        this.description = data.description;
        // Convert Date back to a Unix timestamp in seconds for the API
        this.date = data.date ? Math.floor(data.date.getTime() / 1000) : 0;
    }
}
